<div class="row m-0 p-0 mb-3">
  <div class="col-auto m-0 p-0">
    <div class="user-img-spacer"></div>
  </div>
</div>
<ng-template *ngIf="loading; then loadingTrue else loadingFalse"></ng-template>
<ng-template #loadingTrue>
  <div class="d-flex justify-content-center align-items-center" style="height: 96px;">
    <mat-spinner strokeWidth="2" color="primary" diameter="40"></mat-spinner>
  </div>
</ng-template>
<ng-template #loadingFalse>
  <ng-template *ngIf="error; then isErrorTrue else isErrorFalse"></ng-template>
  <ng-template #isErrorTrue>
    <div class="d-flex justify-content-center align-items-center" style="height: 96px;">
      <div class="text-center">
        <div>{{error?.message}}</div>
        <button class="mx-auto mt-3" mat-stroked-button color="primary" (click)="newDisciplineRecord()">
          Inserisci Provvedimento
        </button>
      </div>
    </div>
  </ng-template>
  <ng-template #isErrorFalse>
    <div class="row m-0 p-0">
      <div class="col-auto m-0 p-0">
        <div class="user-img-spacer"></div>
      </div>
      <div class="col m-0 p-0 ps-3">
        <div class="hstack mb-3">
          <div></div>
          <button class="ms-auto" mat-stroked-button color="primary" (click)="newDisciplineRecord()">
            Inserisci Provvedimento
          </button>
        </div>
        <div class="row m-0 p-0" *ngFor="let disciplineRecord of disciplineRecords;">
          <div class="border rounded p-3 mb-3">
            <div class="d-flex justify-content-between align-items-center">
              <div class="opacity-50">{{disciplineRecord.date | toItDateDdMmmmYyyy}}</div>
              <div class="d-flex align-items-center">
                <div class="opacity-50">{{disciplineRecord.school_year}}</div>
                <div class="ms-2 me-1 opacity-25">|</div>
                <mat-icon class="m-0 p-0 dea-icon-btn" title="Elimina Provvedimento" color="warn"
                  (click)="deleteDisciplineRecord(disciplineRecord.id)">
                  delete
                </mat-icon>
              </div>
            </div>
            <p class="my-2">{{disciplineRecord.text}}</p>
            <div class="d-flex justify-content-end align-items-center opacity-50">
              <div>{{disciplineRecord.author?.getFullName()}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</ng-template>